import styled from "@emotion/styled"
import FormGroup from "@material-ui/core/FormGroup"
import { TStyledFormGroup } from "./types"

export const StyledFormGroup = styled(FormGroup)<TStyledFormGroup>`
  ${({ theme, gap }) => gap && `gap: ${theme.spacing(gap)}`}
`
